import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "station-connected-domains-seperator mt-5 d-none d-md-block" }
const _hoisted_2 = {
  style: {"color":"var(--primary-blue)"},
  width: "1140",
  height: "36"
}

import { computed, onMounted } from "vue";
import Collapsible from "@/collapsible/collapsible.js";
import DomainInfo from "./DomainInfo.vue";
import ConnectedDomainInfo from "./ConnectedDomainInfo.vue";

// Define types for the props
interface DomainsSection {
  data: Record<string, any>;
  stationData: Record<string, any>;
  descriptionText: string;
  season: string;
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'DomainsSection',
  props: {
    data: {},
    stationData: {},
    descriptionText: {},
    season: {}
  },
  setup(__props: any) {



// Computed property for content
const content = computed<Record<string, string>>(() => {
  return window.content || {};
});

// Initialize collapsible elements
const initializeCollapsibleElements = () => {
  const collapsibles = document
    .querySelector("#station-wrapper")
    ?.querySelectorAll(".collapse");
  collapsibles &&
    Array.from(collapsibles).forEach((div) => {
      new Collapsible(div).init();
    });
};

// Lifecycle Hook
onMounted(() => {
  initializeCollapsibleElements();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
        _createElementVNode("use", { href: "#___icon___section-separator" }, null, -1)
      ])))
    ]),
    _createVNode(DomainInfo, {
      data: _ctx.data,
      stationData: _ctx.stationData,
      descriptionText: _ctx.descriptionText,
      season: _ctx.season,
      content: content.value
    }, null, 8, ["data", "stationData", "descriptionText", "season", "content"]),
    _createVNode(ConnectedDomainInfo, {
      data: _ctx.data,
      stationData: _ctx.stationData,
      season: _ctx.season,
      content: content.value
    }, null, 8, ["data", "stationData", "season", "content"])
  ]))
}
}

})